// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"e1fe3115","527":"3349c2dd","614":"591731b0"}[chunkId] + ".chunk.js";
};